import { useState } from 'react';
import PopupWindow from 'views/components/Popup';
import AccordionItem from './AccordianItem';

const data = [
  { title: "Who are you?", content: "Saw.com specializes in acquiring the right domain for your business. We have helped thousands of companies do exactly that. Google us or read our Trustpilot reviews to see for yourself." },
  { title: "How much will the domain name cost?", content: "Every domain is different. Factors like the extension, comparable sales, and market demand all play a role. One of our specialists will give you an appraisal during your consultation." },
  { title: "How long will it take?", content: "Typically anywhere from a few days to several weeks. It depends on how quickly the owner responds and how smoothly negotiations go." },
  { title: "What do you charge for your service?", content: "Our fee is 15% of the negotiated purchase price. A minimum fee of $250 applies." },
  { title: "Do you contact the owner on my behalf anonymously?", content: "Yes. We keep your privacy protected throughout the negotiation." },
  { title: "Do I still pay if the negotiation fails?", content: "You do not pay our commission unless we successfully acquire the domain for you." },
  { title: "How do you determine what to offer?", content: "We assess multiple metrics to evaluate the domain and the owner’s situation, and develop a strategy to secure the best possible price without overpaying. No offer is made without your approval." },
  { title: "What if I do not want to use Saw.com to pay for the domain?", content: "We support a range of trusted payment providers including Escrow.com, Escrow.Domains, industry lawyers, and other well known marketplaces. Tell us your preference when you speak with one of our specialists." },
  { title: "Can you help me acquire domains in any country extension?", content: "Absolutely. Whether it's a .com, a country-specific extension, or anything in between, we have the experience and connections to pursue it on your behalf." },
];

const FaqModal = ({ closePopup }): JSX.Element => {

  const [openIndex, setOpenIndex] = useState<null | number>(null);

  return (
    <PopupWindow onClose={closePopup} className="mw-45 faq-rewamp-modal" header="Frequently Asked Questions" >

      {data.map((item, index) => (
        <AccordionItem
          key={index}
          {...item}
          isOpen={openIndex === index}
          onClick={() =>
            setOpenIndex(openIndex === index ? null : index)
          }
        />
      ))}
    </PopupWindow>
  );
};

export default FaqModal;
